import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../widgets/form/InputTextSF'

const ReceivableFinancingLimitModalUI = ({ context, successMsg, errorList, setErrorList,
  // modes
  updateMode, submitted,
  // event handlers
  onSubmit, onCancelClick,
  // fields
  receivableFinancingLimit, onReceivableFinancingLimitChange, receivableFinancingLimitError, setReceivableFinancingLimitError,
}) =>
  <ModalFormUI
    context={context}
    titleLabel='Receivable financing limit'
    buttonLabel='Set'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <InputTextSF type='text' name='receivableFinancingLimit'
      value={receivableFinancingLimit} onChange={onReceivableFinancingLimitChange}
      error={receivableFinancingLimitError} setError={setReceivableFinancingLimitError}
    />
  </ModalFormUI>

export default ReceivableFinancingLimitModalUI
